import jwt_decode from 'jwt-decode'
import md5 from 'md5'

const token_key = 'token'

export function credentials(username, password) {
  return {'username': username, 'password': md5(password)}
}

export function set_token(token) {
  localStorage.setItem(token_key, token);
}

export function clear_token() {
  localStorage.removeItem(token_key);
}

export function get_token() {
  return localStorage.getItem(token_key);
}

export function has_role(role) {
  let token = get_token();
  if (!token){
    return false;
  }
  let decoded = jwt_decode(token);

  return (decoded.roles.indexOf(role)>=0)
}

export function is_logged_in() {
  return !!get_token();
}

export function get_name() {
  let token = localStorage.getItem('token');
  if (!token){
    return false;
  }
  let decoded = jwt_decode(token);

  return decoded.sub;
}

export function get_user() {
  let token = get_token();
  if (!token){
    return null;
  }
  let decoded = jwt_decode(token);

  return decoded;
}


// WEBPACK FOOTER //
// ./src/utils/auth.js